import React, { memo } from "react";

const CallsListLoader = ({ count = 8 }) => (
  <>
    {Array.from({ length: count }, (_, i) => (
      <div className="callListItemLoader" key={`callListItemLoader${i}`}>
        <div className="callListItemLoader__top">
          <div className="callListItemLoader__info">
            <span className="callListItemLoader__name linear-background" />
            <span className="callListItemLoader__calledBy linear-background" />
          </div>
          <span className="callListItemLoader__outcome linear-background" />
        </div>
        <div className="callListItemLoader__meta">
          <span className="callListItemLoader__date linear-background" />
          <span className="callListItemLoader__duration linear-background" />
        </div>
      </div>
    ))}
  </>
);

export default memo(CallsListLoader);
